import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import { getTranslatedString } from 'helpers/i18n';
import FlatButton from 'material-ui/FlatButton';

import { AccentColor } from 'helpers/AccentColorHelper';

import { pdfjs, Document, Page } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';

pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

const DEFAULT_PAGE_WIDTH = 612;
const VIEWER_PADDING = 16; // 16 of left padding and 16 of right padding

const options = {
  cMapUrl: `https://unpkg.com/pdfjs-dist@${pdfjs.version}/cmaps/`,
  cMapPacked: true,
  standardFontDataUrl: `https://unpkg.com/pdfjs-dist@${pdfjs.version}/standard_fonts`,
};

export const NoticePDFDialog = ({ isOpen, toggleDialog, base64String }) => {
  const [pagesCount, setPagesCount] = React.useState(1);
  const pages = Array.from(new Array(pagesCount));

  function onLoadSuccess(pdf) {
    setPagesCount(pdf.numPages);
  }

  return (
    <Dialog open={isOpen} fullScreen={true} fullWidth={true} maxWidth={'xl'} scroll={'paper'}>
      <div style={{ flex: 1, overflow: 'auto' }}>
        <Document
          file={base64String}
          options={options}
          renderMode="canvas"
          onLoadSuccess={onLoadSuccess}
        >
          {pages.map((_, index) => (
            <Page
              key={`page_${index + 1}`}
              pageNumber={index + 1}
              width={Math.min(DEFAULT_PAGE_WIDTH, window.innerWidth - VIEWER_PADDING * 2)}
            />
          ))}
        </Document>
      </div>

      <DialogActions>
        <FlatButton onClick={toggleDialog} id="close-button" style={{ color: AccentColor() }}>
          {getTranslatedString('close')}
        </FlatButton>
      </DialogActions>
    </Dialog>
  );
};
